import { createFileRoute, redirect } from "@tanstack/react-router"

// The pickup reminders moved to a tab on the shared reminders page; the
// pickup Julo Update still links here.
export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/pickup",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/communication/reminders",
      search: { tab: "pickup" },
      replace: true,
    })
  },
})
